import { RoutePermittedRole } from '@crema/constants/AppEnums';
import React from 'react';
import { BiUser, BiHome, BiListUl, BiPlusCircle, BiCategory, } from 'react-icons/bi';
import {
  MdOutlineManageAccounts,
} from 'react-icons/md';
const routesConfig = [
  {
    id: 'account',
    title: 'Account',
    messageId: 'sidebar.pages.extraPages.account',
    type: 'item',
    icon: <MdOutlineManageAccounts />,
    url: '/my-profile',
    permittedRole: [RoutePermittedRole.Admin, RoutePermittedRole.Seller],
  },
  {
    id: 'seller',
    title: 'Seller',
    messageId: 'sidebar.seller',
    type: 'item',
    icon: <BiUser />,
    url: '/seller/',
    permittedRole: [RoutePermittedRole.Admin]
    // children: [
    //   {
    //     id: 'seller-management',
    //     title: 'Seller Management',
    //     messageId: 'sidebar.seller.management',
    //     type: 'item',
    //     url: '/seller/',
    //     icon: <BiRadioCircleMarked />
    //   }
    // ],
  },
  {
    id: 'realty',
    title: 'Realty',
    messageId: 'sidebar.realty',
    type: 'collapse',
    icon: <BiHome />,
    permittedRole: [RoutePermittedRole.Admin, RoutePermittedRole.Seller],
    children: [
      {
        id: 'realty-management',
        title: 'Realty Management',
        messageId: 'sidebar.realty.management',
        type: 'item',
        url: '/realty/',
        icon: <BiListUl />
      },
      {
        id: 'realty-create',
        title: 'Create Realty',
        messageId: 'sidebar.realty.create',
        type: 'item',
        url: '/realty/create',
        icon: <BiPlusCircle />,
      }
    ],
  },
  {
    id: 'category',
    title: 'Category',
    messageId: 'sidebar.category',
    type: 'collapse',
    icon: <BiCategory />,
    permittedRole: [RoutePermittedRole.Admin],
    children: [
      {
        id: 'category-management',
        title: 'Category Management',
        messageId: 'sidebar.category.management',
        type: 'item',
        url: '/category/',
        icon: <BiListUl />
      },
      {
        id: 'category-create',
        title: 'Category Create',
        messageId: 'sidebar.category.create',
        type: 'item',
        url: '/category/create',
        icon: <BiPlusCircle />
      }
    ],
  },
];
export default routesConfig;
